var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"financialDailyDistribution",staticStyle:{"max-width":"100%","height":"400px","overflow-x":"scroll"}})
}
var staticRenderFns = []

export { render, staticRenderFns }